import {ApplicationConfig, LOCALE_ID, provideZoneChangeDetection} from '@angular/core';
import {provideRouter} from '@angular/router';

import {routes} from './app.routes';
import {provideClientHydration} from '@angular/platform-browser';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi} from '@angular/common/http';
import {BrowserStorageService} from './services/browser-storage/browser-storage.service';
import {AuthenticationInterceptor} from './interceptor/authentication/authentication.interceptor';
import {AuthenticationService} from './services/authentication/authentication.service';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import {MatPaginatorIntl} from '@angular/material/paginator';
import {CustomPaginatorIntl} from './mat-custom-settings/paginator/custom-paginator-intl';
import {MAT_DATE_LOCALE} from '@angular/material/core';
import {provideMomentDateAdapter} from '@angular/material-moment-adapter';
import moment from 'moment';
import 'moment/locale/de';

moment.locale('de');

registerLocaleData(localeDe);

export const MY_DATE_FORMATS = {
    parse: {
        dateInput: 'DD.MM.YYYY',
    },
    display: {
        dateInput: 'DD.MM.YYYY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};

export const appConfig: ApplicationConfig = {
    providers: [
        BrowserStorageService,
        provideZoneChangeDetection({eventCoalescing: true}),
        provideRouter(routes),
        provideClientHydration(),
        provideAnimationsAsync(),
        provideHttpClient(
            withInterceptorsFromDi(),
            withFetch(),
        ),
        AuthenticationService,
        {provide: HTTP_INTERCEPTORS, useClass: AuthenticationInterceptor, multi: true},
        {provide: LOCALE_ID, useValue: 'de'},
        {provide: MAT_DATE_LOCALE, useValue: 'de'},
        provideMomentDateAdapter(MY_DATE_FORMATS),
        { provide: MatPaginatorIntl, useClass: CustomPaginatorIntl },
    ]
};
